import CustomReportStatus from '@/Enums/ReportBuilder/Status.enum';
import { ICustomReport } from '@/Interfaces/ReportBuilder/CustomReport.interface';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';

export const DurationCell = ({ row, value }: GridRenderCellParams<ICustomReport, string>) => {
  const [duration, setDuration] = useState<string>(value || '');

  const calculateDuration = useMemo(() => row.status === CustomReportStatus.Running, [row.status]);

  useEffect(() => {
    let interval = null;
    if (calculateDuration) {
      interval = setInterval(() => {
        setDuration(moment(row.createdAt).fromNow(true));
      }, 1000);
    }
    return () => clearInterval(interval!);
  }, [calculateDuration, row.createdAt]);

  return duration;
};
